import columns from '../../react-table/helpers/columns';
import TableDefinitions from '../../../common/TableDefinitions';

export function editRoute(rowInfo) {
  return rowInfo && rowInfo.row ? {
    path: '/edit-route',
    tableId: TableDefinitions.ROUTE_MANAGEMENT_PAGE.id,
    text: 'Edit',
  } : {};
}

export default (data, assetType, userRoles) => {
  const {
    FilteredTextColumn,
    FilteredTextCommaColumn,
    EditButtonColumn,
    NavigationColumn,
    FilteredBooleanColumn,
    FilteredDateColumn,
  } = columns(data);

  return [
    {
      Header: '',
      columns: [
        new FilteredTextColumn('Outbound Operator', 'outboundOperator'),
        new FilteredTextColumn('Outbound IMPC', 'outboundImpc'),
        new FilteredTextCommaColumn('Transfer Operator', 'transferOperators').withShow(assetType === 'pallet'),
        new FilteredTextCommaColumn('Transfer IMPC', 'transferImpcs').withShow(assetType === 'pallet'),
        new FilteredTextColumn('Inbound Operator', 'inboundOperator'),
        new FilteredTextColumn('Inbound IMPC', 'inboundImpc'),
        new FilteredTextColumn('Priority Type', 'priority'),
        new FilteredDateColumn('Start Date', 'startDate'),
        new FilteredDateColumn('End Date', 'endDate'),
        new FilteredTextColumn('Status', 'status'),
        new FilteredTextColumn('Type', 'type'),
        new FilteredTextColumn('Creator', 'creator'),
        new FilteredTextColumn('Last Updated by', 'lastUpdatedBy'),
        new FilteredBooleanColumn('Exceptional Leading Count', 'hasExceptionalLeadingCount').withShow(assetType === 'pallet'),
        new NavigationColumn(new EditButtonColumn('Action', 'editable').withShow('editable')
          .withShow(
            (assetType === 'tray' && userRoles.includes('IPC_TRAY_MANAGER'))
            || (assetType === 'bag' && userRoles.includes('IPC_BAG_MANAGER'))
            || (assetType === 'pallet' && userRoles.includes('IPC_PALLET_BOX_MANAGER')),
          ), editRoute),
      ],
    },
  ];
};
